// src/pages/ComingSoon.js
import React, { useEffect, useRef } from "react";
import "../styles/ComingSoon.scss";
import comingSoonVideo from "../assets/videos/coming-soon.mp4";

const ComingSoon = () => {
  const videoRef = useRef(null);

  // React sets `muted` as a DOM property but never renders it as an HTML
  // attribute, so the prerendered markup lacked it and browsers blocked
  // autoplay. Setting the attribute here also lands it in the prerendered
  // HTML, and play() covers the hydrated page.
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    video.setAttribute("muted", "");
    video.play().catch(() => {});
  }, []);

  return (
    <main className="coming-soon">
      {/* muted + playsInline are required for autoplay on mobile browsers */}
      <video
        ref={videoRef}
        className="coming-soon-video"
        src={comingSoonVideo}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <div className="coming-soon-overlay" />
      <h1 className="coming-soon-title">Bientôt en ligne</h1>
    </main>
  );
};

export default ComingSoon;
